import React from 'react';
import { skills } from '../data/mock';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Progress } from './ui/progress';

const Skills = () => {
  return (
    <section id="skills" className="py-20 bg-[#0a0a0b]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4">
            Technical <span className="bg-gradient-to-r from-blue-500 to-cyan-500 bg-clip-text text-transparent">Skills</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto rounded-full"></div>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            A comprehensive overview of my technical abilities and proficiencies across various domains of software engineering
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {skills.map((category, categoryIndex) => (
            <Card
              key={categoryIndex}
              className="bg-[#1a1a1b] border-gray-800 hover:border-blue-500/50 transition-all duration-300 overflow-hidden group"
            >
              <CardHeader className="border-b border-gray-800 bg-gradient-to-r from-blue-950/20 to-cyan-950/20 group-hover:from-blue-950/30 group-hover:to-cyan-950/30 transition-all duration-300">
                <CardTitle className="text-2xl text-white">
                  {category.category}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6">
                <div className="space-y-6">
                  {category.items.map((skill, skillIndex) => (
                    <div key={skillIndex} className="space-y-2">
                      <div className="flex justify-between items-center">
                        <h4 className="text-lg font-semibold text-white">
                          {skill.name}
                        </h4>
                        <span className="text-sm text-cyan-400 font-mono">
                          {skill.level}%
                        </span>
                      </div>
                      <Progress
                        value={skill.level}
                        className="h-2 bg-gray-800"
                      />
                      <p className="text-sm text-gray-400">
                        {skill.description}
                      </p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
